import type { InitJsonContext } from '@cli-types/next-adapter/commands.js'

export function writeInitJson(context: InitJsonContext, payload: Record<string, unknown>): void {
  context.restoreStdout?.()
  context.restoreStdout = undefined
  context.written = true
  console.log(JSON.stringify(payload, null, 2))
}
